<template>
  <div
    class="sidebar shadow-around fixed right-0 top-0 z-50 h-[var(--app-height)] bg-white dark:bg-neutral-900 dark:ring-1 dark:ring-neutral-800 md:top-[var(--header-scroll-height)] md:z-30 md:h-[calc(var(--app-height)-var(--header-scroll-height))]"
    :class="{
      [`sidebar-size-${sidebar.size} sidebar-offset-${sidebar.offset}`]: true,
      'sidebar-refresh': isChanging,
    }"
  >
    <div
      class="sticky top-0 z-10 flex h-11 w-full items-center justify-between gap-1 bg-white px-1 dark:bg-neutral-900"
    >
      <div class="max-w-[calc(100%-10*var(--spacing))] grow">
        <slot name="header-content"></slot>
      </div>
      <button
        class="btn btn-primary size-9 shrink-0 justify-center px-0"
        @click.prevent="close"
      >
        <lucide-icon icon="X" size="19" />
      </button>
    </div>
    <!-- v-if="loading" -->

    <div
      class="custom-scroll custom-scroll-accent custom-scroll-y relative h-[calc(100%-11*var(--spacing))] overflow-y-auto pb-2"
    >
      <slot v-if="!loading"></slot>

      <SkeletonLoader
        :active="loading"
        :class="{
          'opacity-0 transition-opacity': !loading,
        }"
        class="pointer-events-none absolute right-0 top-0 z-10 h-full w-full"
      >
        <template
          v-if="sidebar.type == 'details' && sidebar.context == 'instance'"
        >
          <div
            class="mb-5 bg-gray-200 dark:bg-neutral-800"
            :class="{
              'h-90': sidebar.size == 1 || $windowSize.isMobile,
              'h-110': sidebar.size == 2 && !$windowSize.isMobile,
              'h-120': sidebar.size == 3 && !$windowSize.isMobile,
            }"
          ></div>
          <div class="px-2">
            <div
              class="mb-2 h-8 w-[calc(100%-8rem)] rounded-lg bg-gray-200 dark:bg-neutral-800"
            ></div>
            <div class="mb-2 flex flex-wrap gap-x-1 gap-y-1">
              <span
                v-for="index in [1, 2]"
                :key="`loading-primary-tag-${index}`"
                class="w-13 h-5 rounded-full bg-gray-200 dark:bg-neutral-800"
              >
              </span>
            </div>
            <div class="mb-2 flex flex-wrap gap-x-1 gap-y-1">
              <span
                v-for="index in [1, 2, 3]"
                :key="`loading-tag-${index}`"
                class="w-18 h-6 rounded-full bg-gray-200 dark:bg-neutral-800"
              >
              </span>
            </div>
            <div class="mb-1 flex gap-1">
              <div
                class="h-10 grow rounded-lg bg-gray-200 dark:bg-neutral-800"
              ></div>
              <div
                class="size-10 rounded-lg bg-gray-200 dark:bg-neutral-800"
              ></div>
            </div>
            <div class="mb-8 flex gap-1">
              <div
                class="h-10 grow rounded-lg bg-gray-200 dark:bg-neutral-800"
              ></div>
              <div
                class="h-10 grow rounded-lg bg-gray-200 dark:bg-neutral-800"
              ></div>
            </div>

            <div
              class="mb-1 h-5 w-[calc(100%-1rem)] rounded-lg bg-gray-200 dark:bg-neutral-800"
            ></div>
            <div
              class="mb-1 h-5 w-[calc(100%-2rem)] rounded-lg bg-gray-200 dark:bg-neutral-800"
            ></div>
            <div
              class="mb-1 h-5 w-[calc(100%-6.5rem)] rounded-lg bg-gray-200 dark:bg-neutral-800"
            ></div>
          </div>
        </template>
        <template
          v-else-if="sidebar.type == 'preview' || sidebar.type == 'group'"
        >
          <div class="h-90 mb-5 bg-gray-200 dark:bg-neutral-800"></div>
          <div class="px-2">
            <div class="h-30 mb-2 bg-gray-200 dark:bg-neutral-800"></div>
            <div class="h-30 mb-2 bg-gray-200 dark:bg-neutral-800"></div>
            <div class="h-30 mb-2 bg-gray-200 dark:bg-neutral-800"></div>
          </div>
        </template>
        <template v-else>
          <div class="h-90 mb-5 bg-gray-200 dark:bg-neutral-800"></div>
          <div class="px-2">
            <div
              class="mb-1 h-5 w-[calc(100%-1rem)] rounded-lg bg-gray-200 dark:bg-neutral-800"
            ></div>
            <div
              class="mb-1 h-5 w-[calc(100%-2rem)] rounded-lg bg-gray-200 dark:bg-neutral-800"
            ></div>
            <div
              class="mb-1 h-5 w-[calc(100%-6.5rem)] rounded-lg bg-gray-200 dark:bg-neutral-800"
            ></div>
          </div>
        </template>
      </SkeletonLoader>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SkeletonLoader from '@/components/ui/SkeletonLoader';

export default {
  name: 'SidebarTemplate',
  components: {
    SkeletonLoader,
  },
  props: {
    sidebar: {
      type: Object,
      required: true,
    },
    loading: {
      default: false,
    },
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: false,
      isChanging: false,
    };
  },

  computed: {},

  watch: {
    uuid: {
      handler() {
        this.isChanging = true;
        window.eventBus.$emit('sidebar:afterUpdate');
        setTimeout(() => {
          this.isChanging = false;
        }, 320);
      },
      immediate: false,
    },
  },

  methods: {
    ...mapActions(['CLOSE_SIDEBAR']),
    close() {
      this.CLOSE_SIDEBAR(this.sidebar.id).then(() => {});
    },
  },
};
</script>
